import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";

async function pendingRequests(emp_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/actionRequired/employee/pending?emp_id=${emp_id}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const pendingRequestsService = {
  pendingRequests,
};
